import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "wrapper align-left border-radius",
  ref: "modal"
}
const _hoisted_2 = {
  key: 0,
  class: "header flex middle-xs"
}
const _hoisted_3 = { class: "flex between-xs middle-xs" }
const _hoisted_4 = { class: "medium" }
const _hoisted_5 = {
  key: 0,
  class: "align-right"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("OK")

import {
    PropType,
    ref,
    computed,
    ComputedRef,
    onBeforeUnmount,
    watch,
  } from 'vue';
  import { useStore } from 'vuex';
  import { isIOSChrome } from '@/plugins';
  import CloseIcon from '@/views/icons/CloseIcon.vue';
  import ButtonComponent from './ButtonComponent.vue';
  import SpinnerComponent from './SpinnerComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
    state: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<'alert' | 'prompt'>,
      default: 'alert',
    },
    modalName: {
      type: String,
      default: 'info',
    },
    needIOSCheck: {
      type: Boolean,
      default: true,
    },
    clickOutside: {
      type: Boolean,
      default: true,
    },
    disallowClosing: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['modalClose'],
  setup(__props, { emit }) {

const props = __props

  const isFooterPostionRelative = isIOSChrome();
  const store = useStore();

  
  

  const animationEnd = ref<boolean>(false);

  const isMobile: ComputedRef<boolean> = computed(
    () => store.state.support.isMobile,
  );
  const networkEnable: ComputedRef<boolean> = computed(
    () => store.state.support.networkEnable,
  );

  function afterEnter() {
    animationEnd.value = true;
  }

  function beforeLeave() {
    animationEnd.value = false;
  }

  function onClickOutside(event: MouseEvent) {
    if (!props.clickOutside || !networkEnable.value || props.disallowClosing) {
      return;
    }

    if (document.body.contains(event.target as Node) && !isMobile.value) {
      toggleState(false);
    }
  }

  function toggleState(value: boolean) {
    if (value) {
      document.body.classList.add('hidden');
    } else if (!props.disallowClosing) {
      emit('modalClose');
      document.body.classList.remove('hidden');
    }
  }

  watch(
    () => props.state,
    value => {
      toggleState(value);
    },
  );

  onBeforeUnmount(() => {
    document.body.classList.remove('hidden');
  });

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    onAfterEnter: afterEnter,
    onBeforeLeave: beforeLeave
  }, {
    default: _withCtx(() => [
      (__props.state)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["modal middle-sm center-sm", __props.type])
          }, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
              (__props.type === 'prompt' || _unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (__props.isLoading)
                      ? (_openBlock(), _createBlock(SpinnerComponent, {
                          key: 0,
                          color: _unref(isMobile) ? 'white' : null
                        }, null, 8, ["color"]))
                      : _createCommentVNode("", true),
                    _createVNode(CloseIcon, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleState(false))),
                      role: "button"
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h2", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "title")
                      ]),
                      (_ctx.$slots.headerBtn)
                        ? _renderSlot(_ctx.$slots, "headerBtn", { key: 0 })
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["content", {
            'auto-height': _unref(isFooterPostionRelative) && _ctx.$slots.footer,
          }]),
                style: _normalizeStyle(
            _unref(isMobile)
              ? `height: calc(100% - ${_ctx.$slots.footer ? '104' : '0'}px)`
              : ''
          )
              }, [
                _createElementVNode("div", null, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                (__props.type === 'alert' && !_unref(isMobile))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(ButtonComponent, {
                        class: "purpure",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleState(false)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 6),
              (_ctx.$slots.footer && _ctx.$slots.footer())
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "footer border-radius-bottom-sm",
                    style: _normalizeStyle(
            _unref(isFooterPostionRelative)
              ? 'position: relative; box-shadow: none;'
              : ''
          )
                  }, [
                    _renderSlot(_ctx.$slots, "footer")
                  ], 4))
                : _createCommentVNode("", true)
            ])), [
              [_directive_click_outside, onClickOutside]
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})